import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import NotFoundComponent from "./views/NotFoundComponent.vue";
import Login from "./views/Login";
import Templates from "./views/Templates";
import Moderation from "./views/Moderation";
import Authorize from "./views/Authorize";
import Statistics from "./views/Statistics";
import SSO from "./views/SSO";
import Support from "./views/Support";
import SupermoderatorPanel from "./views/SupermoderatorPanel";
import Error from "./views/Error";
import PageReady from "./views/PageReady";
import Profile from "./views/edit/Profile";
import Events from "./views/edit/Events";
import Achievments from "./views/edit/Achievments";
import Products from "./views/edit/Products";
import Social from "./views/edit/Social";
import Backgrounds from "./views/edit/Backgrounds";
import Certificates from "./views/edit/Certificates";
import SelectComponent from "./views/SelectComponent";
import Home2 from "./views/Home2";
import WebViewAuth from "./views/WebViewAuth";
``;
import Wizard1 from "./views/wizards/Wizard1";
import Wizard2 from "./views/wizards/Wizard2";
import Wizard3 from "./views/wizards/Wizard3";

const projectName = "Amway Personal Page";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home2,
      meta: {
        requiresAuth: true,
        title: `Моя страница | ${projectName}`
      }
    },
    {
      path: "/edit",
      name: "edit",
      component: SelectComponent,
      meta: {
        requiresAuth: true,
        title: `Компоненты | ${projectName}`
      }
    },
    {
      path: "/edit/social",
      name: "social",
      component: Social,
      meta: {
        requiresAuth: true,
        title: `Редактирование контактов | ${projectName}`
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true,
        title: `Вход | ${projectName}`
      }
    },
    {
      path: "/templates",
      name: "templates",
      component: Templates,
      meta: {
        requiresAuth: true,
        title: `Выбор шаблона страницы | ${projectName}`
      }
    },
    {
      path: "/prw-moderator",
      name: "moderation",
      component: Moderation,
      meta: {
        title: `Модерация | ${projectName}`
      }
    },
    {
      path: "/moderation/super",
      name: "supermoderator",
      component: SupermoderatorPanel,
      meta: {
        title: `Панель супермодератора | ${projectName}`,
        requiresSuperModer: true
      }
    },
    {
      path: "/authorize",
      name: "authorize",
      component: Authorize,
      meta: {
        title: `Авторизация Amway ID | ${projectName}`
      }
    },
    {
      path: "/webview",
      name: "WebViewAuth",
      component: WebViewAuth,
      meta: {
        title: `Авторизация Amway ID | ${projectName}`
      }
    },
    {
      path: "/edit/events",
      name: "events",
      component: Events,
      meta: {
        requiresAuth: true,
        title: `Мероприятия Amway | ${projectName}`
      }
    },
    {
      path: "/edit/achievements",
      name: "achievements",
      component: Achievments,
      meta: {
        requiresAuth: true,
        title: `Личные достижения | ${projectName}`
      }
    },
    {
      path: "/edit/products",
      name: "products",
      component: Products,
      meta: {
        requiresAuth: true,
        title: `Продукты | ${projectName}`
      }
    },
    {
      path: "/statistics",
      name: "statistics",
      component: Statistics,
      meta: {
        requiresAuth: true,
        title: `Статистика страницы | ${projectName}`
      }
    },
    {
      path: "/loginsso",
      name: "sso",
      component: SSO,
      meta: {
        title: `Переадресация на авторизацию | ${projectName}`
      }
    },
    {
      path: "/support",
      name: "Support",
      component: Support,
      meta: {
        title: `Единый Контактный Центр Amway | ${projectName}`
      }
    },
    {
      path: "/401",
      name: "Login Error",
      component: Error,
      props: {
        type: "login_error"
      },
      meta: {
        title: `Произошла ошибка входа! | ${projectName}`
      }
    },
    {
      path: "/edit/profile",
      name: "Contacts edit",
      component: Profile,
      meta: {
        requiresAuth: true,
        title: `Контактные данные | ${projectName}`
      }
    },
    {
      path: "/edit/backgrounds",
      name: "Backgrounds edit",
      component: Backgrounds,
      meta: {
        requiresAuth: true,
        title: `Фон страницы | ${projectName}`
      }
    },
    {
      path: "/edit/certificates",
      name: "Certificates edit",
      component: Certificates,
      meta: {
        requiresAuth: true,
        title: `Мои сертификаты | ${projectName}`
      }
    },
    {
      path: "/403",
      name: "Authorization Error",
      component: Error,
      props: {
        type: "auth_error"
      },
      meta: {
        title: `Похоже, что у вас нет доступа | ${projectName}`
      }
    },
    {
      path: "/wizard/4",
      name: "Page ready",
      component: PageReady,
      meta: {
        title: `Поздравляем! Ваша страница готова!  | ${projectName}`
      }
    },
    {
      path: "/404",
      component: NotFoundComponent,
      meta: {
        title: `Страница не найдена | ${projectName}`
      }
    },
    {
      path: "/home",
      component: Home2,
      meta: {
        title: `Управление страницей | ${projectName}`
      }
    },
    {
      path: "/wizard/1",
      component: Wizard1,
      meta: {
        requiresAuth: true,
        title: `Настройка контактных данных | ${projectName}`
      }
    },
    {
      path: "/wizard/2",
      component: Wizard2,
      meta: {
        requiresAuth: true,
        title: `Выбор шаблона | ${projectName}`
      }
    },
    {
      path: "/wizard/3",
      component: Wizard3,
      meta: {
        requiresAuth: true,
        title: `Настройка компонентов | ${projectName}`
      }
    },
    {
      path: "*",
      component: NotFoundComponent
    }
  ]
});

router.beforeEach((to, from, next) => {
  router.app.$eventBus.$emit("mobile_menu_opened", false);
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.name === "sso") {
    next();
  }
  if (to.matched.some(record => record.meta.restrictedFor)) {
    store.state.user.user_type.forEach(ut => {
      if (to.meta.restrictedFor.includes(ut.code)) {
        next({
          path: "/"
        });
      }
    });
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.user) {
      next({
        path: "/login"
      });
    } else if (store.state.user.step < 4) {
      if (store.state.user.step === 3) {
        next();
      } else if (to.path === `/wizard/${store.state.user.step}`) {
        next();
      } else {
        next({
          path: `/wizard/${store.state.user.step}`
        });
      }
    } else if (/\/wizard/.test(to.path)) {
      next();
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (store.state.user) {
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresSuperModer)) {
    if (!store.state.moderator || !store.state.moderator.super_moder) {
      next({
        path: "/moderation"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
